var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAggregate = function SvgAggregate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 4.5a.5.5 0 0 0-.5.5v.533a.5.5 0 1 0 1 0V5.5h.033a.5.5 0 1 0 0-1zM7.133 4.5a.5.5 0 0 0 0 1H8.2a.5.5 0 0 0 0-1zM9.8 4.5a.5.5 0 0 0 0 1h1.067a.5.5 0 0 0 0-1zM13.5 7.133a.5.5 0 0 0-1 0V8.2a.5.5 0 0 0 1 0zM5.5 7.133a.5.5 0 0 0-1 0V8.2a.5.5 0 0 0 1 0zM13.5 9.8a.5.5 0 0 0-1 0v1.067a.5.5 0 0 0 1 0zM5.5 9.8a.5.5 0 0 0-1 0v1.067a.5.5 0 0 0 1 0zM13.5 12.467a.5.5 0 1 0-1 0v.033h-.033a.5.5 0 1 0 0 1H13a.5.5 0 0 0 .5-.5zM7.133 12.5a.5.5 0 0 0 0 1H8.2a.5.5 0 0 0 0-1zM9.8 12.5a.5.5 0 0 0 0 1h1.067a.5.5 0 0 0 0-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.5 1A.5.5 0 0 1 1 .5h12a.5.5 0 0 1 .5.5v3.5H17a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5v-3.5H1a.5.5 0 0 1-.5-.5zm12 3.5v-3h-11v11h3v-.033a.5.5 0 1 1 1 0v.033h.033a.5.5 0 0 1 0 1H5.5v3h11v-11h-3v.033a.5.5 0 0 1-1 0V5.5h-.033a.5.5 0 1 1 0-1z",
    clipRule: "evenodd"
  })));
};
export { SvgAggregate as ReactComponent };
export default __webpack_public_path__ + "415586ba33d5537ffeb87ed2c287121f.svg";